import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var BoardService = (function () {
    function BoardService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    BoardService.prototype.getBoardList = function (filterParams) {
        var url = this.apiUrl + 'api/cms/board/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        params.append("sortNew", filterParams.sortNew);
        var body = JSON.stringify({});
        return this.http.post(url, body, { headers: headers, params: params })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return BoardService;
}());
export { BoardService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/board/board.service.ts.pre-build-optimizer.js